var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "grid_table_holder" }, [
    _c("table", { staticClass: "table_basic" }, [
      _c("tbody", [
        _c("tr", [
          _c("th", {
            directives: [
              {
                name: "t",
                rawName: "v-t",
                value: "CELL_BASELINE_BID",
                expression: "'CELL_BASELINE_BID'"
              }
            ],
            attrs: { scope: "row" }
          }),
          _vm._v(" "),
          _c("td", [
            _vm._v(
              "\n          " + _vm._s(_vm.bidTrace.BaselineBid) + "\n        "
            )
          ])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", {
            directives: [
              {
                name: "t",
                rawName: "v-t",
                value: "CELL_ADJUSTMENTS",
                expression: "'CELL_ADJUSTMENTS'"
              }
            ],
            attrs: { scope: "row" }
          }),
          _vm._v(" "),
          _c(
            "td",
            [
              _vm.bidTrace.Adjustments && _vm.bidTrace.Adjustments.length > 0
                ? _c(
                    "span",
                    {
                      staticClass: "clickable text-underline",
                      on: {
                        click: function($event) {
                          _vm.showAdjustments = !_vm.showAdjustments
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("VIEW")) +
                          "\n            "
                      ),
                      _c("i", {
                        staticClass: "fa fa-angle-right m-l-5",
                        class: { "fa-rotate-90": _vm.showAdjustments },
                        attrs: { "aria-hidden": "true" }
                      })
                    ]
                  )
                : [_vm._v(_vm._s(_vm.$t("N_A")))]
            ],
            2
          )
        ]),
        _vm._v(" "),
        _vm.bidTrace.Adjustments && _vm.bidTrace.Adjustments.length > 0
          ? _c(
              "tr",
              {
                staticClass: "hidden-row",
                class: { expanded: _vm.showAdjustments }
              },
              [
                _c(
                  "td",
                  { attrs: { colspan: "2" } },
                  [
                    _c(
                      "collapse",
                      {
                        model: {
                          value: _vm.showAdjustments,
                          callback: function($$v) {
                            _vm.showAdjustments = $$v
                          },
                          expression: "showAdjustments"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "rtb-dashboard__rtb-log-detail-adjustments"
                          },
                          _vm._l(_vm.bidTrace.Adjustments, function(
                            adjustment,
                            index
                          ) {
                            return _c("RtbAdjustment", {
                              key: index,
                              attrs: { adjustment: adjustment }
                            })
                          }),
                          1
                        )
                      ]
                    )
                  ],
                  1
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.bidTrace.FinalBid
          ? _c("tr", [
              _c("th", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "CELL_FINAL_BID",
                    expression: "'CELL_FINAL_BID'"
                  }
                ],
                attrs: { scope: "row" }
              }),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "\n          " + _vm._s(_vm.bidTrace.FinalBid) + "\n        "
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("tr", [
          _c("th", {
            directives: [
              {
                name: "t",
                rawName: "v-t",
                value: "CELL_MAX_BID",
                expression: "'CELL_MAX_BID'"
              }
            ],
            attrs: { scope: "row" }
          }),
          _vm._v(" "),
          _c("td", [
            _vm._v("\n          " + _vm._s(_vm.bidTrace.MaxBid) + "\n        ")
          ])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", {
            directives: [
              {
                name: "t",
                rawName: "v-t",
                value: "CELL_MIN_DURATION_ADJUSTMENTS",
                expression: "'CELL_MIN_DURATION_ADJUSTMENTS'"
              }
            ],
            attrs: { scope: "row" }
          }),
          _vm._v(" "),
          _c(
            "td",
            [
              _vm.bidTrace.MinDurationAdjustments &&
              _vm.bidTrace.MinDurationAdjustments.length > 0
                ? _c(
                    "span",
                    {
                      staticClass: "clickable text-underline",
                      on: {
                        click: function($event) {
                          _vm.showMinDurationAdjustments = !_vm.showMinDurationAdjustments
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("VIEW")) +
                          "\n            "
                      ),
                      _c("i", {
                        staticClass: "fa fa-angle-right m-l-5",
                        class: {
                          "fa-rotate-90": _vm.showMinDurationAdjustments
                        },
                        attrs: { "aria-hidden": "true" }
                      })
                    ]
                  )
                : [_vm._v(_vm._s(_vm.$t("N_A")))]
            ],
            2
          )
        ]),
        _vm._v(" "),
        _vm.bidTrace.MinDurationAdjustments &&
        _vm.bidTrace.MinDurationAdjustments.length > 0
          ? _c(
              "tr",
              {
                staticClass: "hidden-row",
                class: { expanded: _vm.showMinDurationAdjustments }
              },
              [
                _c(
                  "td",
                  { attrs: { colspan: "2" } },
                  [
                    _c(
                      "collapse",
                      {
                        model: {
                          value: _vm.showMinDurationAdjustments,
                          callback: function($$v) {
                            _vm.showMinDurationAdjustments = $$v
                          },
                          expression: "showMinDurationAdjustments"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "rtb-dashboard__rtb-log-detail-adjustments"
                          },
                          _vm._l(_vm.bidTrace.MinDurationAdjustments, function(
                            adjustment,
                            index
                          ) {
                            return _c("RtbAdjustment", {
                              key: index,
                              attrs: { adjustment: adjustment }
                            })
                          }),
                          1
                        )
                      ]
                    )
                  ],
                  1
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.bidTrace.FinalMinDuration
          ? _c("tr", [
              _c("th", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "CELL_FINAL_MIN_DURATION",
                    expression: "'CELL_FINAL_MIN_DURATION'"
                  }
                ],
                attrs: { scope: "row" }
              }),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.bidTrace.FinalMinDuration) +
                    " sec\n        "
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.hasOverridesObject
          ? _c("tr", [
              _c("th", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "CELL_PUBLISHER_OVERRIDES",
                    expression: "'CELL_PUBLISHER_OVERRIDES'"
                  }
                ],
                attrs: { valign: "top", scope: "row" }
              }),
              _vm._v(" "),
              _c(
                "td",
                [
                  _vm.hasOverrides
                    ? _c(
                        "ul",
                        { staticClass: "m-l-10" },
                        _vm._l(_vm.activeOverrides, function(override, index) {
                          return _c("li", { key: index }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(override) +
                                "\n            "
                            )
                          ])
                        }),
                        0
                      )
                    : [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("N_A")) +
                            "\n          "
                        )
                      ]
                ],
                2
              )
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }